import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React, {useRef} from "react";
import Typography from "@material-ui/core/Typography";
import {getMessage} from "../../util";

const Captcha = (props) => {

    const captcha2 = useRef()
    const site_key2 = process.env.REACT_APP_ENTERPRISE_RECAPTCHA_SITE2;

    const renderCaptcha = (data) => {


        window.grecaptcha.enterprise.render(captcha2.current, {
            'sitekey': site_key2, 'callback': async (token) => {
                props.handleClose();
                data.gRecaptchaResponse = token;
                data.rechallenge = true;
                props.setLoading(true);

                props.connect(data);
            }
        });
    }

    return (<Dialog
        open={props.open}
        scroll="body"
        onEntered={() => renderCaptcha(props.data)}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle
            id="alert-dialog-title">{getMessage(props.meeting.meeting_type, 'captcha_title', props.messages)}</DialogTitle>
        <DialogContent>
            <Typography id="alert-dialog-description">
                {getMessage(props.meeting.meeting_type, 'captcha_try_message', props.messages)}
            </Typography>
            <div ref={captcha2}></div>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" onClick={props.handleClose} color="primary" autoFocus>
                {getMessage(props.meeting.meeting_type, 'close', props.messages)}
            </Button>
        </DialogActions>
    </Dialog>)
}

export default Captcha;